import React from 'react';

const SvgTriangleActive = ({
  cx,
  cy,
  color,
  mouseEnter,
  mouseLeave,
  index
}) => (
  <svg
    cx={cx}
    cy={cy}
    x={cx - 10}
    y={cy - 10}
    fill={color}
    width={18}
    height={18}
    onMouseEnter={() => mouseEnter(cx, cy, index)}
    onMouseLeave={() => mouseLeave()}
  >
    <defs>
      <filter
        id="triangleActive_svg__a"
        width="220%"
        height="220%"
        x="-60%"
        y="-60%"
        filterUnits="objectBoundingBox"
      >
        <feOffset in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
          stdDeviation={2}
        />
        <feComposite
          in="shadowBlurOuter1"
          in2="SourceAlpha"
          operator="out"
          result="shadowBlurOuter1"
        />
        <feColorMatrix
          in="shadowBlurOuter1"
          values="0 0 0 0 0.82745098 0 0 0 0 0.337254902 0 0 0 0 0.211764706 0 0 0 0.5 0"
        />
      </filter>
      <path id="triangleActive_svg__b" d="M265.046 50L270 60h-10z" />
    </defs>
    <g fill="none" transform="translate(-256 -46)">
      <use
        fill="#000"
        filter="url(#triangleActive_svg__a)"
        xlinkHref="#triangleActive_svg__b"
      />
      <path
        fill="#FFF"
        fillRule="evenodd"
        stroke={color}
        strokeLinejoin="square"
        strokeWidth={2}
        d="M265.038 52.236L261.625 59h6.764l-3.351-6.764z"
      />
    </g>
  </svg>
);

export default SvgTriangleActive;
